import React from "react";

const PrivacyPolicy = () => {
  const effectiveDate = "December 7, 2022";
  const lastUpdated = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="container py-5 text-dark">
      <section id="Header">
        <div className="row">
          <div className="col-12 text-center">
            <h1 className="fs-2 fw-bold">PRIVACY POLICY</h1>
            <div className="text-end mb-1">Effective Date: {effectiveDate}</div>
            <div className="text-end mb-1">Last Updated on: {lastUpdated}</div>
            <div className="text-end">Website Covered: aspiron.ai</div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12">
            <div className="mb-3">
              <p>
                This Privacy Policy explains how we collect, use, protect, and manage your Personally
                Identifiable Information (PII) when you use our website, blog, or application. PII
                refers to information that can be used to identify or contact a person. Please read
                carefully.
              </p>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Information We Collect</h2>
              <div>
                <p>We may collect the following information when you interact with our services:</p>
                <ul>
                  <li>Name</li>
                  <li>Email address</li>
                  <li>Mailing address</li>
                  <li>Phone number</li>
                  <li>Credit card or payment details</li>
                  <li>Other relevant information to improve your experience</li>
                </ul>
              </div>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">When We Collect Information</h2>
              <ul>
                <li>Register on our site</li>
                <li>Place an order or subscription</li>
                <li>Subscribe to newsletters</li>
                <li>Respond to surveys or marketing communications</li>
                <li>Enter information on our website or app</li>
              </ul>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">How We Use Your Information</h2>
              <ul>
                <li>Personalize your experience and content</li>
                <li>Process transactions securely</li>
                <li>Send periodic emails on orders, products, services, or promotions</li>
                <li>Improve website/app usability and customer service</li>
              </ul>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Protecting Visitor Information</h2>
              <ul>
                <li>Data is stored behind secure networks with restricted access</li>
                <li>Sensitive information (payments) is encrypted via SSL</li>
                <li>Financial transactions processed through secure payment gateways only</li>
                <li>Security measures applied during transactions to protect data</li>
              </ul>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Use of Cookies</h2>
              <p>
                We use cookies to improve user experience, remember preferences, track ads, and
                analyze site/app traffic. You may disable cookies in your browser, but some features
                may not function properly.
              </p>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Third-Party Disclosure</h2>
              <p>
                We do not sell, trade, or transfer personal information except to trusted partners
                who agree to keep it confidential. We may disclose information as required by law.
              </p>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Third-Party Links</h2>
              <p>
                Our site/app may include links to third-party services with independent privacy
                policies. We are not responsible for their content or practices.
              </p>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Google AdSense & Advertising</h2>
              <ul>
                <li>
                  We use Google AdMob (AdSense for Apps) to display ads. Google may use cookies
                  or device identifiers to serve ads based on prior visits.
                </li>
                <li>
                  You can manage Google Ads preferences via Google Ads Settings or opt-out via
                  Network Advertising Initiative.
                </li>
                <li>We comply with Google’s advertising policies for a safe user experience.</li>
              </ul>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Payment Information</h2>
              <p>
                For subscription-based services or in-app purchases, we collect payment information
                (credit/debit card, UPI, etc.) via secure payment gateways. Payment details are
                never stored on our servers. Your transaction data is encrypted and processed securely.
              </p>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">User Rights & Choices</h2>
              <ul>
                <li>Visit our site/app anonymously</li>
                <li>Access and update personal information via account settings</li>
                <li>Be notified of changes to this policy</li>
              </ul>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Do Not Track</h2>
              <p>
                We respect “Do Not Track” browser signals. Currently, we do not alter behavior
                based on DNT.
              </p>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Behavioral Tracking</h2>
              <p>
                Third-party behavioral tracking may be used to improve advertising relevance.
              </p>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Data Breach Policy</h2>
              <ul>
                <li>
                  We will notify affected users via email or chat within 7 business days in case
                  of a data breach.
                </li>
                <li>
                  Users may seek legal remedies against data collectors or processors who violate
                  this policy or applicable laws.
                </li>
              </ul>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Email Communication & Anti-Spam</h2>
              <ul>
                <li>Respond to inquiries and requests</li>
                <li>Send updates regarding orders, products, services, or promotions</li>
                <li>All emails include our physical business address</li>
                <li>Users can unsubscribe anytime via provided links</li>
              </ul>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Grievance Redressal</h2>
              <p>
                Contact us for privacy concerns or complaints:
                <br />
                <strong>Email:</strong> contact_grievances@gmail.com
              </p>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Children’s Information</h2>
              <p>
                Our services are not intended for children under 13. We do not knowingly collect
                personal data from children.
              </p>
            </div>

            <div className="mb-3">
              <h2 className="fs-5">Contact Details</h2>
              <ul>
                <li>Name: Aditya Kumar</li>
                <li>Phone: 040-35162621</li>
                <li>Email: info@aspiron.ai</li>
                <li>
                  Address: Floor 6B-C, Bizness Square Building, Opposite Hitex Kaman, Hitech City
                  Rd, Laxmi Cyber City, White Fields, HITEC City, Hyderabad, Telangana 500081
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;